import { dateObjToLocalZone, trimString } from '../../../utils/converter';
// import { convertToKb } from '../../../utils/fileHelpers';

export const FileDetails = ({ reportData }) => {
  return (
    <div className="flex flex-col rounded-lg bg-[#17191C] p-4 sm:p-6 gap-4 sm:gap-6">
      <h3 className="font-normal text-xl md:text-2xl">File Details</h3>
      <table className="w-full table-fixed file-table">
        <tbody className="w-full flex flex-col gap-1">
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Name:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base break-words">
              {trimString(reportData.FILE_NAME)}
            </td>
          </tr>
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Hash:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base break-all">
              {reportData.HASH}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// OLD
// export const FileDetails = ({ reportData }) => {
//   return (
//     <div className="flex flex-col rounded-[20px] bg-[#17191C] p-[24px] gap-[24px]">
//       <h3 className="text-[28px] space-y-[33.6px]">File Details</h3>
//       <table className="w-full table-fixed file-table">
//         <tbody className="w-full flex flex-col gap-[2px]">
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Name:</th>
//             <td className="">{trimString(reportData.FILE_NAME)}</td>
//           </tr>
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Size:</th>
//             <td className="">{convertToKb(reportData.FILE_SIZE)}</td>
//           </tr>
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Last Modified:</th>
//             <td className="">{dateObjToLocalZone(reportData.FILE_DATE)}</td>
//           </tr>
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Hash:</th>
//             <td className="">{reportData.HASH}</td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };
